import { Component, inject, OnInit } from '@angular/core';
import { AppStore } from '@projects/adir/src/app/app.store';
import { Profile } from '@projects/adir/src/interfaces/profile.interface';
import { NotificationButtonComponent } from '@shared/src/lib/components/notification-button/notification-button.component';
import { ProfileComponent } from '@shared/src/lib/components/profile/profile.component';
import { HelpIconComponent } from '@shared/src/lib/icons/help-icon/help-icon.component';

@Component({
  selector: 'lib-navigation-header',
  standalone: true,
  imports: [HelpIconComponent, NotificationButtonComponent, ProfileComponent],
  templateUrl: './navigation-header.component.html',
  styleUrl: './navigation-header.component.css',
})
export class NavigationHeaderComponent implements OnInit {
  protected readonly appStore = inject(AppStore);
  ngOnInit(): void {
    // TODO: Read from response and set
    this.appStore.state.profile.displayName.set('');
    this.appStore.state.profile.imageURL.set('');
  }

  get profile(): Profile.Response {
    return {
      displayName: this.appStore.state.profile.displayName(),
      imageURL: this.appStore.state.profile.imageURL(),
    };
  }
}
